import { useState } from 'react'
import { Element } from '../../../common/html/element'
import classes from './classes.module.scss'

const styles = {
  ACTIVE: {
    color: '#0553A5',
    backgroundColor: '#E5F2FF',
  },
  INACTIVE: {
    color: '#191D25',
    backgroundColor: '',
  },
  DEFAULT_ACTIVE: {
    color: '#0553A5',
    backgroundColor: '',
  },
}

const DropdownItem = ({ item, onClickItem, activeItem }) => {
  const isActive = item.value === activeItem.value
  const [style, setStyle] = useState(
    isActive ? styles.DEFAULT_ACTIVE : styles.INACTIVE,
  )

  const onMouseEnter = () => {
    setStyle(styles.ACTIVE)
  }

  const onMouseLeave = () => {
    setStyle(isActive ? styles.DEFAULT_ACTIVE : styles.INACTIVE)
  }

  const onClick = () => {
    onClickItem(item)
  }

  return (
    <Element
      onClick={onClick}
      className={classes.dropdownItem}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ ...style }}
    >
      {item.label}
      <Element
        style={{ backgroundColor: '#D5D5D5' }}
        className={classes.borderBottom}
      />
    </Element>
  )
}

export default DropdownItem
